import script from "./ConsumerMypageWishListView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumerMypageWishListView.vue?vue&type=script&setup=true&lang=js"

import "./ConsumerMypageWishListView.vue?vue&type=style&index=0&id=99fab0b4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99fab0b4"]])

export default __exports__